import { gsap } from 'gsap';

export default class CollectionTimeline {
	constructor(el) {
		this.el = el;

		gsap.to(this.el, {
			xPercent: -50,
			repeat: -1,

			duration: 100,
			ease: 'none',
		});
	}
}
